import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  label: {
    color: theme.palette.text.disabled,
  },
  sortBy: {
    minWidth: 90,
    color: theme.palette.text.disabled,
    marginRight: '16px',
  },
}));
